export default "__VITE_ASSET__Be4Y4vYJ__"